/**
 * @description 委托书表单字段
 */
import get from 'lodash/get'
import { i18n, getBDCountry, sprintf } from '@/common/utils/i18n'
const country = getBDCountry() || 'MX'

import { formatPics, filterParams } from '@/common/utils/format'

// 对后端接口下发的数据做格式转换
export function revert (data = {}) {
  const proxy = get(data, 'bizGlobal.docInfo.proxy')
  if (!proxy) return {}
  return {
    licensePics: formatPics(proxy.licensePics),
    files: formatPics(proxy.files)
  }
}

export function submitFormat (proxyInfo) {
  return {
    params: JSON.stringify({
      source: 'contractor',
      queryId: this.$route.params.id,
      bizGlobal: {
        ...proxyInfo.bizGlobal,
        country: country
      }
    })
  }
}

export default {
  revert,
  submitFormat
}
